var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cartao-menu-item"}},[_c('div',[_c('b-icon',{attrs:{"icon":_vm.icone,"font-scale":_vm.tamanhoFonte}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"link"},[_c('a',{attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.descricaoLink))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }